module.exports = __webpack_public_path__ + "img/free-1.8a4a715a.png";